import React, { useCallback, useEffect, useState } from "react";
import { Task, TaskType } from "../../../types";
import { Button } from "@bandit-network/react-ui-kit";
import {
  CheckCircledIcon,
  ExternalLinkIcon,
  ReloadIcon,
} from "@radix-ui/react-icons";
import { getTarget, getUrl } from "../../../utils";
import { useQuestContext } from "../../../context/QuestContext";
import { useConnect } from "@bandit-network/react-wallet-kit";
import { replaceHyperlinks } from "../../../utils/hyperlink";

export interface JoinProps {
  data: Task;
}

const Join: React.FC<JoinProps> = ({ data }) => {
  const { questSDK, tasksCompleted } = useQuestContext();
  const [isConnected, setIsConnected] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { address } = useConnect();

  const getUserProfile = useCallback(async () => {
    try {
      setIsRefreshing(true);
      const userProfile = await questSDK.getUserProfile(address);
      if (userProfile?.socialmedia?.telegram?.length > 0) {
        setIsConnected(true);
      } else {
        setIsConnected(false);
      }
    } catch (e) {
      console.log("error : ", e);
    } finally {
      setIsRefreshing(false);
    }
  }, [questSDK, address]);

  useEffect(() => {
    getUserProfile();
  }, [getUserProfile]);

  const join = useCallback(() => {
    window.open(
      getUrl(TaskType.TELEGRAM_JOIN, data.args.channelUsername),
      getTarget(),
      "height=600,width=600",
    );
  }, [data]);

  const connect = useCallback(() => {
    setTimeout(() => {
      setIsClicked(true);
    }, 2500);
    window.open(
      data.args.telegramRedirectLink,
      getTarget(),
      "height=600,width=600",
    );
  }, [data]);

  const isTaskComplete = tasksCompleted.includes(data?.id);
  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      <div className="bad-quest__task--action_wrapper">
        {!isConnected && (
          <Button
            size="sm"
            className="bad-quest__task--action_button"
            onClick={connect}
            disabled={isRefreshing}
          >
            Connect
            <ExternalLinkIcon className="bad-quest__task--link_icon" />
          </Button>
        )}
        {!isConnected && isClicked && (
          <ReloadIcon
            className={`ml-2 mt-2 bad-quest_action_button-reload${
              !isRefreshing ? "-stop" : ""
            }`}
            onClick={getUserProfile}
          />
        )}
      </div>
      {isConnected && (
        <Button
          size="sm"
          className="bad-quest__task--action_button"
          onClick={join}
          disabled={isTaskComplete}
        >
          {isTaskComplete ? `Completed` : `Join`}
          {isTaskComplete ? (
            <CheckCircledIcon className="bad-quest__task--check_icon" />
          ) : (
            <ExternalLinkIcon className="bad-quest__task--link_icon" />
          )}
        </Button>
      )}
    </div>
  );
};

export { Join };
